if (!customElements.get('bewo-poltrona-hero')) {
  class BewoPoltronaHero extends HTMLElement {
    constructor() {
      super();
      this.sliderInstance = false;
    }

    connectedCallback() {
      if (this.dataset.enableSlider !== 'true') return;

      this.sliderEl = this.querySelector('.bewo-poltrona-hero__swiper');
      this.paginationEl = this.querySelector('.bewo-poltrona-hero__pagination');
      if (!this.sliderEl) return;

      const autoplayDelay = Number(this.dataset.autoplay || 0);
      const slideCount = Number(this.dataset.slideCount || 0);

      const options = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: slideCount > 1,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        watchOverflow: true,
        allowTouchMove: slideCount > 1,
      };

      if (this.paginationEl) {
        options.pagination = {
          el: this.paginationEl,
          clickable: true,
          bulletClass: 'bewo-poltrona-hero__bullet',
          bulletActiveClass: 'is-active',
        };
      }

      if (autoplayDelay > 0) {
        options.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      this.sliderInstance = new window.BewoTheme.Carousel(
        this.sliderEl,
        options,
        [window.BewoTheme.Swiper.Autoplay, window.BewoTheme.Swiper.EffectFade]
      );

      this.sliderInstance.init();

      if (this.sliderInstance.slider) {
        this.sliderInstance.slider.update();
      }
    }

    disconnectedCallback() {
      this.sliderInstance?.slider?.destroy(true, true);
      this.sliderInstance = false;
    }
  }

  customElements.define('bewo-poltrona-hero', BewoPoltronaHero);
}
